export const API_BASE_URL = 'https://api.test.smartminesafety.com/api/v1/';
